import SolSystem from './sol.json';
import AlphaCentauri from './alpha-centauri.json';

export default [
    SolSystem,
    AlphaCentauri
];